import { render, staticRenderFns } from "./PDPTimer.vue?vue&type=template&id=830d6954&scoped=true&"
import script from "./PDPTimer.vue?vue&type=script&lang=js&"
export * from "./PDPTimer.vue?vue&type=script&lang=js&"
import style0 from "./PDPTimer.vue?vue&type=style&index=0&id=830d6954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830d6954",
  null
  
)

export default component.exports